<ng-toggle
  [color]="color"
  [disabled]="disabled"
  [switchColor]="switchColor"
  (ngModelChange)="toggle.emit($event); model = $event"
  id="toggle-{{ uniqueId }}"
  [(ngModel)]="model"
  height="22"
  width="40"
></ng-toggle>

<label *ngIf="label" [class]="labelClassName ? labelClassName : null" [for]="'toggle-' + uniqueId">{{ label }}</label>
